var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.getError && _vm.expedition!==null)?_c('div',{staticClass:"container"},[_c('ExpeditionDetails',{model:{value:(_vm.expedition),callback:function ($$v) {_vm.expedition=$$v},expression:"expedition"}})],1):_c('div',[_vm._v(" Pas d'expédition ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }